import "./RemoveTaskGroup.scss";

function RemoveTaskGroup({ cancelRemoveTaskGroup, removeTaskGroup }) {
  return (
    <div className="remove-task-group-content">
      <div className="modal-title">
        <div>Remove Section</div>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to delete this section?</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveTaskGroup}>
          Cancel
        </button>
        <button className="modal-button delete" onClick={removeTaskGroup}>
          Remove
        </button>
      </div>
    </div>
  );
}

export default RemoveTaskGroup;
